import './storefront-vendor';

import { vendor } from './app/vendor';
import { modules } from './app/modules';

let app = angular.module('spabooker', [
    ...vendor,
    ...modules,
])
    .config(['$locationProvider', '$urlRouterProvider', function ($locationProvider) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
            rewriteLinks: false
        });
    }])
    .config(['uiSelectConfig', function (uiSelectConfig) {
        uiSelectConfig.theme = 'select2';
    }])
    .run(['$transitions', '$window', '$rootScope', '$state', ($transitions, $window, $rootScope, $state) => {
        $transitions.onSuccess({}, () => {
            $window.scrollTo(0, 280);
        });

        // Silence transition errors (and any other $state error...)
        $state.defaultErrorHandler(function (error) {
            console.log(error);
        });

        $rootScope.$on('$locationChangeSuccess', function () {
            if (typeof analytics !== 'undefined') {
                analytics.page();
            }
        });
    }]);

export default app;



// WEBPACK FOOTER //
// ./frontend/storefront/storefront.js